import script from "./BackgroundGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackgroundGallery.vue?vue&type=script&setup=true&lang=ts"

import "./BackgroundGallery.vue?vue&type=style&index=0&id=85575e42&lang=scss"

const __exports__ = script;

export default __exports__